module.exports = __webpack_public_path__ + "assets/img/usk-0.01ba2a5b.png";